<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h1><i class="fas fa-chart-line"></i> {{ $t('_ybp._wdsy') }}</h1>
      <!-- <div class="header-actions">
        <button class="btn-refresh" @click="refreshData"><i class="fas fa-sync-alt"></i> 刷新</button>
        <button class="btn-export" @click="exportData"><i class="fas fa-download"></i> 导出</button>
      </div> -->
    </div>

    <!-- 当前余额 -->
    <div class="balance-card">
      <div class="balance-header">
        <h2>{{ $t('_ybp._dqye') }}</h2>
        <!-- <span class="balance-update">更新于 {{ updateTime }}</span> -->
      </div>
      <div class="balance-amount">
        <span class="amount">{{ formatCurrency(profit.total) }}</span>
        <span class="currency">USD</span>
      </div>
      <div class="balance-change">
        <div class="change-amount asedt" :class="profit?.today_profit?.profit >= 0 ? 'positive' : 'negative'">
          <i class="fas" :class="profit?.today_profit?.profit >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          {{ $t('_ybp._jr') }}{{ profit?.today_profit?.profit >= 0 ? '+' : '' }}${{ Math.abs(profit?.today_profit?.profit) }}
          <div :class="profit?.today_profit?.rate >= 0 ? 'positive' : 'negative'">({{ profit?.today_profit?.rate >= 0 ? '+' : '' }}{{ profit?.today_profit?.rate }}%)</div>
        </div>
      </div>
    </div>

    <!-- 收益统计 -->
    <div class="stats-grid">
      <div class="ybp-stat-card">
        <div class="stat-header">
          <h3>{{ $t('_ybp._jrzsy') }}</h3>
          <div class="stat-amount">{{ formatCurrency(profit.total_profit.today) }}</div>
        </div>
        <div class="stat-box stat-zx">
          <div class="stat-comparison">{{ $t('_ybp._ljzsy') }}</div>
          <div style="color: #fff">{{ formatCurrency(profit.total_profit.total) }}</div>
        </div>
      </div>

      <!-- <div class="ybp-stat-card">
        <div class="stat-header">
          <h3>邊看邊賺</h3>
          <div class="stat-amount">{{ formatCurrency(profit.watch_profit.today) }}</div>
        </div>
        <div class="stat-box stat-zx">
          <div class="stat-comparison">累計收益</div>
          <div>{{ formatCurrency(profit.watch_profit.total) }}</div>
        </div>
      </div> -->

      <div class="ybp-stat-card">
        <div class="stat-header">
          <h3>{{ $t('_ybp._tgfh') }}</h3>
          <div class="stat-amount">{{ formatCurrency(profit.video_adv.today) }}</div>
        </div>
        <div class="stat-box stat-zx">
          <div class="stat-comparison">{{ $t('_ybp._ljsy') }}</div>
          <div style="color: #fff">{{ formatCurrency(profit.video_adv.total) }}</div>
        </div>
      </div>

      <div class="ybp-stat-card">
        <div class="stat-header">
          <h3>{{ $t('_ybp._bqsy') }}</h3>
          <div class="stat-amount">{{ formatCurrency(profit.video_invest.today) }}</div>
        </div>
        <div class="stat-box stat-zx">
          <div class="stat-comparison">{{ $t('_ybp._ljsy') }}</div>
          <div style="color: #fff">{{ formatCurrency(profit.video_invest.total) }}</div>
        </div>
      </div>

      <!-- 邀请分红 -->
      <!-- <div class="ybp-stat-card">
        <div class="stat-header">
          <h3>{{ $t('_ybp._yqfh') }}</h3>
          <div class="stat-amount">{{ formatCurrency(profit.inv_profit.today) }}</div>
        </div>
        <div class="stat-box stat-zx">
          <div class="stat-comparison">{{ $t('_ybp._ljsy') }}</div>
          <div>{{ formatCurrency(profit.inv_profit.total) }}</div>
        </div>
      </div> -->
    </div>

    <!-- 每日收益图表 -->
    <div class="chart-section">
      <div class="chart-header">
        <h2>{{ $t('_ybp._mrsy') }}</h2>
        <!-- <div class="chart-controls">
          <button v-for="period in timePeriods" :key="period.value" :class="['period-btn', { active: selectedPeriod === period.value }]" @click="changePeriod(period.value)">
            {{ period.label }}
          </button>
        </div> -->
      </div>
      <div class="chart-container">
        <div class="chart-legend">
          <!-- <div class="legend-item">
            <span class="legend-color watch-earn"></span>
            <span>邊看邊賺</span>
          </div> -->
          <div class="legend-item">
            <span class="legend-color ybp-copyright"></span>
            <span>{{ $t('_ybp._bqsy') }}</span>
          </div>
          <div class="legend-item">
            <span class="legend-color ad-revenue"></span>
            <span>{{ $t('_ybp._tgsy') }}</span>
          </div>
        </div>
        <div class="chart" ref="chart">
          <div class="chart-bars">
            <div v-for="(item, i) in incomeList" :key="i" class="chart-bar-group" :style="{ left: `${(i / (incomeList.length - 1)) * 100}%` }">
              <div class="bar-container">
                <!-- <div class="bar watch-earn-bar" :style="{ height: `${(item.income / maxTotal) * 80}%` }" :title="`邊看邊賺: $${day.watchEarn}`"></div> -->
                <div class="bar copyright-bar" :style="{ height: `${(item.profit / maxTotal) * 80}%` }" :title="$t('_ybp._bqsy') + `: $${item.profit}`"></div>
                <div class="bar ad-revenue-bar" :style="{ height: `${(item.income / maxTotal) * 80}%` }" :title="$t('_ybp._tgsy') + `: $${item.income}`"></div>
              </div>
              <div class="chart-label">{{ item.date }}</div>
            </div>
          </div>
          <div class="chart-y-axis">
            <div v-for="tick in yAxisTicks" :key="tick" class="y-tick">${{ tick }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EarningsDashboard',
  data() {
    return {
      profit: {
        assets_line: {
          usdt: {
            '09/23': 0,
            '09/24': 0,
            '09/25': 0,
            '09/26': 0,
            '09/27': 0,
            '09/28': 0,
            '09/29': 0,
            '09/30': 0
          }
        },
        month_profit: {
          pre: 0,
          profit: 0,
          rate: 0
        },
        profit_line: {
          '09/23': 0,
          '09/24': 0,
          '09/25': 0,
          '09/26': 0,
          '09/27': 0,
          '09/28': 0,
          '09/29': 0,
          '09/30': 0
        },
        today_profit: {
          pre: 0,
          profit: 0,
          rate: 0
        },
        total: 0,
        year_profit: {
          pre: 0,
          profit: 0,
          rate: 0
        },
        watch_profit: {
          today: 0,
          total: 0
        },
        video_adv: {
          today: 0,
          total: 0
        },
        total_profit: {
          today: 0,
          total: 0
        },
        video_invest: {
          today: 0,
          total: 0
        },
        inv_profit: {
          today: 0,
          total: 0
        }
      },

      incomeList: []
    }
  },
  created() {
    this.getProfit()
  },
  computed: {
    maxTotal() {
      const max = Math.max(...this.incomeList.map((item) => item.total))
      return Math.ceil(max / 0.2) * 0.2 // 向上取整到最近的0.2
    },
    yAxisTicks() {
      const ticks = []
      for (let i = 0; i <= 5; i++) {
        ticks.push(((this.maxTotal * i) / 5).toFixed(1))
      }
      return ticks
    }
  },
  methods: {
    getProfit() {
      let that = this
      this.$api.profit.getProfit().then((res) => {
        that.profit = res.data
        for (var date in that.profit.profit_line) {
          let income = that.profit.income_line[date]
          let profit = that.profit.profit_line[date]
          that.incomeList.push({
            date: date,
            income: income,
            profit: profit,
            total: income + profit
          })
        }

        console.log(that.incomeList)
      })
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amount)
    },
    formatTime(date) {
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   仪表盘 - 大气深色主题（参考 login.vue）
   ============================================================ */
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #0b0d0f;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  color: #e8edf2;
}

.dashboard-header h1 {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #e8edf2;
}

.dashboard-header h1 i {
  margin-right: 10px;
  color: #ffb300;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.btn-refresh,
.btn-export {
  background: rgba(255, 179, 0, 0.1);
  border: 1px solid #2a3038;
  color: #e8edf2;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.btn-refresh:hover,
.btn-export:hover {
  background: rgba(255, 179, 0, 0.18);
  transform: translateY(-2px);
}

.balance-card {
  background: #1a1f26;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  border: 1px solid #2a3038;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.balance-header h2 {
  margin: 0;
  color: #8a949f;
  font-size: 18px;
  font-weight: 600;
}

.balance-update {
  color: #4a5662;
  font-size: 14px;
}

.balance-amount {
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
}

.amount {
  font-size: 48px;
  font-weight: 700;
  color: #ffb300;
  margin-right: 10px;
}

.currency {
  font-size: 24px;
  color: #8a949f;
  font-weight: 500;
}

.balance-change {
  font-size: 16px;
  font-weight: 600;
}

.change-amount.positive {
  color: #27ae60;
}

.change-amount.negative {
  color: #e74c3c;
}

.change-amount .positive {
  color: #27ae60;
}

.change-amount .negative {
  color: #e74c3c;
}

.asedt {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.ybp-stat-card {
  background: #1a1f26;
  border-radius: 15px;
  padding: 25px;
  border: 1px solid #2a3038;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: center;
}

.ybp-stat-card:hover {
  transform: translateY(-5px);
  border-color: #ffb300;
}

.stat-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.stat-header h3 {
  margin: 0;
  color: #8a949f;
  font-size: 16px;
  font-weight: 600;
}

.stat-header i {
  color: #ffb300;
  font-size: 20px;
}

.stat-box {
  flex: 1;
}

.stat-zx {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-amount {
  font-size: 28px;
  font-weight: 700;
  color: #e8edf2;
  margin-bottom: 5px;
}

.stat-comparison {
  color: #fff;
  font-size: 14px;
}

.chart-section {
  background: #1a1f26;
  border-radius: 20px;
  padding: 30px;
  border: 1px solid #2a3038;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.chart-header h2 {
  margin: 0;
  color: #e8edf2;
  font-size: 20px;
  font-weight: 600;
}

.chart-controls {
  display: flex;
  gap: 10px;
}

.period-btn {
  background: #0a0d0f;
  border: 1px solid #2a3038;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #8a949f;
}

.period-btn.active {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  border-color: #ffb300;
  font-weight: 600;
}

.chart-container {
  position: relative;
}

.chart-legend {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #8a949f;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.legend-color.watch-earn {
  background: #ffb300;
}

.legend-color.ad-revenue {
  background: #e74c3c;
}

.legend-color.ybp-copyright {
  background: #27ae60;
}

.chart {
  height: 300px;
  position: relative;
  border-left: 1px solid #2a3038;
  border-bottom: 1px solid #2a3038;
  margin-left: 60px;
}

.chart-bars {
  position: relative;
  height: 100%;
  width: calc(100% - 60px);
}

.chart-bar-group {
  position: absolute;
  bottom: -21px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bar-container {
  display: flex;
  align-items: flex-end;
  height: 200px;
  gap: 2px;
  margin-bottom: 10px;
}

.bar {
  width: 12px;
  border-radius: 2px 2px 0 0;
  transition: all 0.3s ease;
}

.bar:hover {
  opacity: 0.8;
  transform: scaleY(1.05);
}

.watch-earn-bar {
  background: #ffb300;
}

.ad-revenue-bar {
  background: #e74c3c;
}

.copyright-bar {
  background: #27ae60;
}

.chart-label {
  font-size: 12px;
  color: #4a5662;
  white-space: nowrap;
}

.chart-y-axis {
  position: absolute;
  left: -60px;
  top: 0;
  bottom: 30px;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 10px;
}

.y-tick {
  font-size: 12px;
  color: #4a5662;
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 15px;
  }

  .dashboard-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .chart-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .chart {
    margin-left: 50px;
  }

  .chart-y-axis {
    left: -50px;
    width: 40px;
  }
}
</style>
